import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=4238b541&scoped=true&"
import script from "./PurchaseModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=4238b541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238b541",
  null
  
)

export default component.exports